import apiClient from "@/shared/services/api/apiClient.js";
import { CandidateFilters, ScheduleInterviewPayload } from "../types";

export type { CandidateFilters };

export const getCandidates = async ({
  page = 1,
  limit = 25,
  search = "",
  department = "All",
  status = "All",
  minATSScore = "",
}: CandidateFilters = {}) => {
  const params = new URLSearchParams();

  params.set("page", String(page));
  params.set("limit", String(limit));

  if (search.trim()) {
    params.set("search", search.trim());
  }

  if (department && department !== "All") {
    params.set("department", department);
  }

  if (status && status !== "All") {
    params.set("status", status);
  }

  if (minATSScore !== "" && minATSScore !== null && minATSScore !== undefined) {
    params.set("minATSScore", String(minATSScore));
  }

  return apiClient.get(`/hr-dashboard/candidates?${params.toString()}`);
};

export const getCandidateDetails = async (
  applicationId: string
) => {
  return apiClient.get(
    `/hr-dashboard/candidates/${applicationId}`,
    { showLoader: true } as any
  );
};

export const downloadCandidateResume = async (applicationId: string) => {
  return apiClient.get(
    `/hr-dashboard/candidates/${applicationId}/resume/download`,
    { responseType: "blob" }
  );
};


export const downloadCandidateVideo = async (
  applicationId: string
) =>
  apiClient.get(
    `/hr-dashboard/candidates/${applicationId}/video/download`,
    {
      responseType: "blob",
      showLoader: false,
    } as any
  );



export const updateCandidateStatus = (
  applicationId: string,
  status: string,
  reason?: string
) =>
  apiClient.patch(
    `/hr-dashboard/candidates/${applicationId}/status`,
    { status, reason },
    { showLoader: false } as any
  );


export const getJobApplicants = async (jobId: string) => {
  return apiClient.get(`/jobs/${jobId}/applicants`);
};


export const updateHRNotes = (
  applicationId: string,
  hrNotes: string
) =>
  apiClient.patch(
    `/hr-dashboard/candidates/${applicationId}/notes`,
    { hrNotes },
    { showLoader: false } as any
  );

export const scheduleInterview = async (
  applicationId: string,
  interviewDetails: ScheduleInterviewPayload
) => {
  return apiClient.patch(
    `/hr-dashboard/candidates/${applicationId}/interview`,
    interviewDetails
  );
};

export const generateAIReport = async (
  applicationId: string
) => {
  return apiClient.post(
    `/hr-dashboard/candidates/${applicationId}/generate-ai-report`
  );
};